export default __webpack_public_path__ + "static/media/ic_aland_islands.5ceb67d8.svg";